import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Router, RouterModule } from '@angular/router';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

@Component({
  selector: 'franbase-link-dropdown-item',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, RouterModule, NzTabsModule],
  templateUrl: './link-dropdown-item.component.html',
  styleUrls: ['./link-dropdown-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkDropdownItemComponent {
  @Input() item: any;
  @Input() isShowDropdown = false;
  @Output() setDropdown = new EventEmitter();

  router = inject(Router);
  private wasInside = false;

  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }

  @HostListener('document:click')
  clickout() {
    if (!this.wasInside) {
      this.handleSetDropdown(false);
    }
    this.wasInside = false;
  }

  handleSetDropdown(value: boolean) {
    this.setDropdown.emit(value);
  }

  log(args: any[]): void {
    // console.log(args);
  }
}
